import { api } from '@@/services/api';

export const userApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getMe: builder.query<Alacaza.User, void>({
      query: () => `partners/me`,
      providesTags: ['Users'],
    }),
    getUserById: builder.query<Alacaza.Resident, string>({
      query: (userId) => `users/${userId}`,
      providesTags: ['Residents'],
    }),
  }),
});

export const { useGetMeQuery, useGetUserByIdQuery } = userApi;
